/**
 * Returns a block field by its name, or undefined when not found.
 * @param {Array} fields - block fields
 * @param {string} fieldName - field name
 * @returns {Object|undefined}
 */
export const getFieldByName = (fields, fieldName) => {
    return fields?.find((field) => field.name === fieldName);
};
